import {defineStore} from 'pinia'
import {NetworkService} from "~/utils/NetworkService";

export const superAdminStore = defineStore({
    id: 'super-admin-store',
    persist: true,
    state: () => {
        return {
            transfers: <any[]>[],
            transferPagination: <any>{},
            companies: <any[]>[],
            companiesPagination: <any>{},
            revenueDashboard: <any>{},
            schoolRevenueReport: <any[]>[],
            schoolReportPagination: <any>{},
            schoolsWithRevenue: <any[]>[],
            loading: false
        }
    },
    actions: {
        getStripeBalance: async function () {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/stripe-balance';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, {}, null, 'stripeBalance' + new Date().getMilliseconds());
            return response?.Result;
        },
        getTransferHistory: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/transfers';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, filters, null, 'transferHistory' + new Date().getMilliseconds());
            if (response?.Result) {
                this.transfers = response.Result.transfers || [];
                this.transferPagination = response.Result.pagination || {};
            }
            return response?.Result;
        },
        getCompanies: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/companies';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, filters, null, 'companies' + new Date().getMilliseconds());
            if (response?.Result) {
                this.companies = response.Result.companies || [];
                this.companiesPagination = response.Result.pagination || {};
            }
            return response?.Result;
        },
        // School-wise revenue report
        getRevenueDashboard: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/dashboard';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, filters, null, 'revenueDashboard' + new Date().getMilliseconds());
            if (response?.Result) {
                this.revenueDashboard = response.Result;
            }
            return response?.Result;
        },
        getSchoolRevenueReport: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/school-report';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, filters, null, 'schoolReport' + new Date().getMilliseconds());
            if (response?.Result) {
                this.schoolRevenueReport = response.Result.rows || [];
                this.schoolReportPagination = response.Result.pagination || {};
            }
            return response?.Result;
        },
        exportSchoolRevenueReport: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/export';
            const ns = new NetworkService();
            return await ns.post$fetch(url, filters, null, 'exportReport' + new Date().getMilliseconds());
        },
        getSchoolsWithRevenue: async function () {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/schools';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, {}, null, 'schoolsWithRevenue' + new Date().getMilliseconds());
            if (response?.Result) {
                this.schoolsWithRevenue = response.Result || [];
            }
            return response?.Result;
        },
        // Transfer school revenue to seller connect account
        transferSchoolRevenueToAccount: async function (sellerId: string, items: any[], note?: string) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/school-transfer-to-account';
            const ns = new NetworkService();
            const body: any = { sellerId, items };
            if (note) body.note = note;
            return await ns.post$fetch(url, body, null, 'schoolTransferToAccount' + new Date().getMilliseconds());
        },
        // Get super admin connected accounts
        getSuperAdminAccounts: async function () {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/accounts';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, {}, null, 'superAdminAccounts' + new Date().getMilliseconds());
            return response?.Result || [];
        },
        // Get withdraw-to-bank history
        getWithdrawHistory: async function (filters: any = {}) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/revenue/withdraw-history';
            const ns = new NetworkService();
            const response = await ns.post$fetch(url, filters, null, 'withdrawHistory' + new Date().getMilliseconds());
            return response?.Result;
        },
        // Request payout from seller connect account to bank
        requestPayout: async function (payload: any) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/seller/payout';
            const ns = new NetworkService();
            return await ns.post$fetch(url, payload, null, 'requestPayout' + new Date().getMilliseconds());
        },
        // Seller account management
        onboardSeller: async function (payload: any) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/seller/onboard';
            const ns = new NetworkService();
            return await ns.post$fetch(url, payload, null, 'onboardSeller' + new Date().getMilliseconds());
        },
        getSellerStatus: async function (sellerId?: string) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/seller/get';
            const ns = new NetworkService();
            return await ns.post$fetch(url, sellerId ? {sellerId} : {}, null, 'getSellerStatus' + new Date().getMilliseconds());
        },
        getSellerDashboardLink: async function (sellerId?: string) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/seller/dashboard-link';
            const ns = new NetworkService();
            return await ns.post$fetch(url, sellerId ? {sellerId} : {}, null, 'sellerDashboard' + new Date().getMilliseconds());
        },
        getSellerBalance: async function (sellerId?: string) {
            const config = useRuntimeConfig();
            const url = config.public.baseUrlSops + '/api/super-admin/seller/balance';
            const ns = new NetworkService();
            return await ns.post$fetch(url, sellerId ? {sellerId} : {}, null, 'sellerBalance' + new Date().getMilliseconds());
        },
        clearSuperAdminStore: function () {
            this.transfers = [];
            this.transferPagination = {};
            this.companies = [];
            this.companiesPagination = {};
            this.revenueDashboard = {};
            this.schoolRevenueReport = [];
            this.schoolReportPagination = {};
            this.schoolsWithRevenue = [];
            this.loading = false;
        }
    },
    getters: {
        getTransfers: state => state.transfers,
        getTransferPagination: state => state.transferPagination,
        getCompaniesData: state => state.companies,
        getCompaniesPagination: state => state.companiesPagination,
        getRevenueDashboardData: state => state.revenueDashboard,
        getSchoolRevenueReportData: state => state.schoolRevenueReport,
        getSchoolReportPaginationData: state => state.schoolReportPagination,
        getSchoolsWithRevenueData: state => state.schoolsWithRevenue,
        isLoading: state => state.loading
    }
})
